export default __webpack_public_path__ + "static/media/termsOfUse.fbb2d44a.pdf";